(function () {
  'use strict';

  angular.module('app.influencerOverview', ['daterangepicker', 'slickCarousel'])

    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('home.influencerOverview', {
            requireLogin: true,
            url: 'influencerOverview/:influencer_id',
            templateUrl: 'app/influencerOverview/influencerOverview.html?app_v=deployDate',
            controller: 'influencerOverviewCtrl',
            scope: {},
            data: {
                authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
                navMarker: ['influencerOverview']
            },
            params: {
                influencer_id: null
            }
        })
    }]);
})();